export default "__VITE_ASSET__GfR1bfCi__"